import { BridgeComponent } from "@hotwired/strada"

export default class extends BridgeComponent {
  static component = "search-bar"
  static targets = ["input"]
  static values = { placeholder: String }

  connect() {
    super.connect()
    this.notified = false
    this.onBridgeReady = () => this.notifyBridgeOfConnect()
    document.addEventListener("web-bridge:ready", this.onBridgeReady)

    this.bridgeComponentsObserver = new MutationObserver(() => {
      this.notifyBridgeOfConnect()
    })
    this.bridgeComponentsObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-bridge-components"]
    })

    this.notifyBridgeOfConnect()
  }

  disconnect() {
    if (this.notified && this.enabled) {
      this.send("deactivateSearch")
    }

    document.removeEventListener("web-bridge:ready", this.onBridgeReady)
    this.bridgeComponentsObserver?.disconnect()
    super.disconnect()
  }

  inputTargetConnected() {
    this.notifyBridgeOfConnect()
  }

  notifyBridgeOfConnect() {
    if (this.notified || !this.enabled || !this.hasInputTarget) return

    const placeholder = this.inputTarget.getAttribute("data-placeholder") || this.placeholderValue
    const query = this.inputTarget.value || ""

    this.notified = true

    this.send("connect", { placeholder, query }, (message) => {
      this.applyQuery(message.data?.query ?? "")
    })
  }

  applyQuery(query) {
    if (this.inputTarget.value !== query) {
      this.inputTarget.value = query
    }

    if (this.isGlobalSearch) {
      const page = this.element.closest(".global-search-page") ||
        document.querySelector('.global-search-page[data-controller~="search"]') ||
        this.element.closest('[data-controller~="search"]')
      const searchRoot = page?.querySelector(".global-search--native-bridge") ||
        page?.querySelector(".global-search.global-search--page") ||
        this.element.closest(".global-search")
      const controller = searchRoot
        ? window.Stimulus?.getControllerForElementAndIdentifier(searchRoot, "search")
        : page && window.Stimulus?.getControllerForElementAndIdentifier(page, "search")
      if (controller?.loadSearchResults && controller.hasFormTarget) {
        controller.loadSearchResults()
        return
      }
      if (controller?.search) {
        controller.search()
        return
      }
    }

    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))

    if (this.isGlobalSearch) return

    this.inputTarget.form?.requestSubmit()
  }

  get isGlobalSearch() {
    return this.inputTarget.form?.dataset.searchGlobal === "true"
  }

  activateSearch() {
    this.inputTarget.disabled = false
  }

  deactivateSearch() {
    this.inputTarget.disabled = true
  }
}
